var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloudprint-listentry"},[(_vm.editable)?_c('v-btn',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){$event.stopPropagation();_vm.edit = !_vm.edit}}},[(_vm.edit)?_c('TText',{attrs:{"value":"done"}}):_c('TText',{attrs:{"value":"rename"}})],1):_vm._e(),_vm._t("default",null,{"edit":_vm.edit})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }